'use client';

import type { ToolUIPart } from 'ai';

import { StreamingToolText } from '@/features/copilot/ui/Tool';

export interface UpdateTextFieldToolCardProps {
  toolCallId: string;
  state: ToolUIPart['state'];
  input: unknown;
  output?: unknown;
  errorText?: string;
}

export function UpdateTextFieldToolCard({ state, input }: UpdateTextFieldToolCardProps) {
  if (state !== 'input-streaming' && state !== 'input-available' && state !== 'output-available') {
    return null;
  }

  const value =
    typeof input === 'object' && input !== null
      ? (input as Record<string, unknown>).value
      : undefined;

  return (
    <StreamingToolText
      text={typeof value === 'string' ? value : undefined}
      isStreaming={state === 'input-streaming'}
    />
  );
}
